// eslint-disable-next-line no-var
export var apiUrlPath = {
  url: '',
  urlBase: '',
};
